export class CanvasEvent {

  static FIT_CANVAS:string = 'CanvasFitCanvas'
  static SET_SELECT_MODE: string = "CanvasSetSelectMode";
  static SET_PAN_MODE: string = "CanvasSetPanMode";
  static SET_ZOOM_IN_MODE: string = "CanvasSetZoomInMode";
  static SET_ZOOM_OUT_MODE: string = "CanvasSetZoomOutMode";
  static ROTATE_CANVAS: string = "CanvasRotateCanvas";
  static SET_CROP_MODE: string = "CanvasSetCropMode";
  static CENTER_LAYER_VERTICALLY: string = "CanvasCenterLayerVertically";
  static CENTER_LAYER_HORIZONTALLY: string = "CanvasCenterLayerHorizontally";

  public type: string;

  /**
   * Constructor
   */
  constructor(type: string) {
    this.type = type;
  }
}
